<div class="chat-chart" *ngIf="chartData; else fallbackTpl">
  <div class="chat-chart__header">
    <h4 class="chat-chart__title" *ngIf="title">{{ title }}</h4>
    <button class="chat-chart__download" type="button" title="Descargar PNG" (click)="downloadPng()">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
        <polyline points="7 10 12 15 17 10"></polyline>
        <line x1="12" y1="15" x2="12" y2="3"></line>
      </svg>
      PNG
    </button>
  </div>
  <div #chartWrapper>
    <p-chart [type]="chartType" [data]="chartData" [options]="chartOptions" [style]="{ height: '220px' }"></p-chart>
  </div>
</div>
<ng-template #fallbackTpl>
  <pre class="chat-chart__raw" *ngIf="fallbackRaw">{{ fallbackRaw }}</pre>
</ng-template>
